import { SupabaseGroupedMomentAnalyticsDataService } from "../../../../modules/stats/server/analytics-service";
import { useSupabaseLoader } from "../../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../../server/supabase/hooks/types";
import type { UUID } from "../../../../utils/uuid";
import { extractDelivereds } from "../../polls/context/calculate-poll-results";
import type { PollRecipient } from "../../polls/context/moment-polls-context";
import { transformGroupedMomentAnalytics } from "./utils";

export const useMomentDeliveredsTotals = (
  moment_id: UUID,
): UseSupabaseLoaderState<PollRecipient[]> => {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const resp = await new SupabaseGroupedMomentAnalyticsDataService(supabase).getAll(
        account_id,
        {
          filter: [{ key: "moment_id", operator: "eq", value: moment_id }],
          order: [{ column: "account_id" }],
        },
      );

      if (resp.error) throw resp.error;

      return extractDelivereds({
        rows: resp.data.map((d, i) => transformGroupedMomentAnalytics(d, i)),
      });
    },
    [moment_id],
  );
};
